import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FooterLogo extends Vue {
    @Prop({ default: '#000000' })
    color: string;
}
